import Styleguide from '../features/styleguide';

export default Styleguide;
